export enum AppErrorType {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

const AppErrorTypeMessage = {
  SAVED_SUCCESSFULLY: 'saved successfully',
  UPDATED_SUCCESSFULLY: 'updated successfully',
};

export { AppErrorTypeMessage };
